<template>
  <h2
    :class="[
      'asc-surface--title',
      upperCase ? 'asc-surface--title-upperCase' : '',
    ]"
  >
    {{ title }}
  </h2>
</template>

<script>
export default {
  name: 'AscSurfaceTitle',

  props: {
    title: {
      type: String,
      required: true,
    },
    upperCase: {
      type: Boolean,
      default: true,
    },
  },
}
</script>

<style lang="scss">
h2.asc-surface--title {
  font-size: 14px !important;
  letter-spacing: 1px !important;
  line-height: 18px;
  font-weight: 500 !important;
  margin-bottom: 14px;

  &-upperCase {
    text-transform: uppercase;
  }
}
</style>
